import React from "react";
import Loadable from "react-loadable";

import DotSpinner from "@exovera/dot-spinner";

function Loading() {
	return (
		<div className="map__loader">
			<DotSpinner color="#1cc2ff" />
		</div>
	);
}

const USATexas23MapLoader = Loadable.Map({
	loader: {
		MapComponent: () => import(/* webpackChunkName: "map" */ "genericComponents/Map"),
		usaMapObject: () => import(/* webpackChunkName: "map" */ "lib/maps/usMap--texas23-alt.js"),
		// usaMapObject: () => import(/* webpackChunkName: "map" */ "lib/maps/usTexas.js"),
		reactSimpleMaps: () => import(/* webpackChunkName: "map" */ "react-simple-maps"),
		texas23: () => import(/* webpackChunkName: "map" */ "lib/maps/texas23.js"),
		mapIndex: () => import(/* webpackChunkName: "map" */ "lib/maps/mapIndexTexas23.js"),
		baseIcon: () => import(/* webpackChunkName: "map" */ "lib/maps/tinyUSA.js"),
	},
	loading: Loading,
	render(loaded, props) {
		const { actions } = props;
		const Map = loaded.MapComponent.default;
		const mapIndex = loaded.mapIndex.default;
		const baseIcon = loaded.baseIcon.default;
		const usaMapObject = loaded.usaMapObject.default;
		const texas23 = loaded.texas23.default;
		const { reactSimpleMaps } = loaded;
		return (
			<Map
				{...props}
				reactSimpleMaps={reactSimpleMaps}
				baseIcon={baseIcon}
				baseMapObject={usaMapObject}
				// Map expects `states` to be an object with the data for each state
				states={texas23}
				mapIndex={mapIndex}
				clickableStates={["48", "texas23", "ElPaso", "SanAntonio"]}
				highlightable={[{ name: "Texas 23rd", geoState: "texas23" }]}
				allowLocationFiltersDuringHighlight
				// trigger remount between detailed and base maps (prevents awkward transition)
				key={props.mapHighlight ? "mapHighlight" : "baseMap"}
				clearMap={actions.clearMap}
				mapHighlightDisabled={false}
				mapId={props.mapId ? props.mapId : "base"}
				subtractFromHeight={360}
				// actions
				clearMapPlay={actions.clearMapPlay}
				clickMap={actions.clickMap}
				hoverMap={actions.hoverMap}
				incrementMapPosition={actions.incrementMapPosition}
				setMapPosition={actions.setMapPosition}
				toggleMapPlay={actions.toggleMapPlay}
				unhoverMap={actions.unhoverMap}
			/>
		);
	},
});

export default USATexas23MapLoader;
